import { useState } from "react";
import { Link } from "react-router-dom";
import type { Faq } from "@/types/content";

export default function FaqSection({ faqs }: { faqs: Faq[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="font-label text-xs tracking-[0.28em] text-accent-700">FAQ</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            吃瓜常见问题
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于榜单怎么排、内容是否可信、如何投稿，这里集中回答。还有疑问可以在
            <Link
              to="/contact"
              className="mx-1 text-primary-600 underline decoration-primary-300 underline-offset-4"
            >
              联系我们
            </Link>
            页面留言。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div key={item.q}>
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpen(isOpen ? null : idx)}
                      className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-5"
                    >
                      <span className="text-sm font-medium text-foreground-950 md:text-base">
                        {item.q}
                      </span>
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500">
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="px-4 pb-5 text-sm leading-relaxed text-foreground-600 md:px-5">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}